import { useState } from "react";
import Page from "@/components/layout/Page";
import { BlogModal } from "@/components/BlogModal";

// Placeholder array - paste blog entries here manually
const blogPosts = [
  {
    id: "black-friday-10-off",
    title: "Unwrap Incredible Black Friday Deals with 10 Percent Off Using Code blackfriday25",
    author: "samboards19",
    date: "2024-11-10",
    readTime: "3 min read",
    content: `
The holiday season is here, and so are the savings you've been waiting for. Right now, you can enjoy a 10% discount on all products by using the code blackfriday25 at checkout. This limited-time offer is perfect for getting a head start on your Christmas shopping while keeping your budget intact.

Whether you're shopping for gifts or treating yourself, this Black Friday deal makes it easier to find something special without breaking the bank. Keep reading to discover how to make the most of this offer and why now is the best time to shop.

Why Black Friday Is the Best Time to Shop for Christmas Gifts

Black Friday has become synonymous with incredible deals and early holiday savings. Many shoppers wait all year for this moment to grab presents at a fraction of the usual price. The 10% discount with code blackfriday25 adds even more value to your purchases, making it a smart choice for anyone looking to save.

Shopping early means you avoid the last-minute rush and the risk of popular items selling out. Plus, spreading out your gift buying over several weeks reduces stress and helps you stick to your budget.

How to Use the Black Friday Discount Code

Using the code blackfriday25 is simple and straightforward:

1. Add your favorite products to the shopping cart.
2. Enter the code blackfriday25 at checkout.
3. See the 10% discount applied instantly to your total.

Remember, this offer is limited to one code per customer, so plan your purchases carefully to maximize your savings. The discount applies to all products, so feel free to mix and match items to suit your needs.

Top Tips for Maximizing Your Black Friday Savings

To get the most out of this deal, consider these practical tips:

- Make a list of gifts you want to buy to stay focused and avoid impulse purchases.
- Check product reviews to ensure you're choosing quality items.
- Compare prices to confirm you're getting the best deal, even with the discount.
- Shop early to avoid missing out on popular products.

By following these steps, you can enjoy a smooth shopping experience and make sure every gift is thoughtful and affordable.

Gift Ideas That Shine with the Black Friday Discount

Here are some popular gift categories where the 10% discount can make a big difference:

- Tech gadgets like headphones, smartwatches, or wireless chargers.
- Home essentials such as cozy blankets, kitchen tools, or decorative items.
- Fashion accessories including scarves, hats, or stylish bags.
- Toys and games for kids of all ages.

Each category offers plenty of options to suit different tastes and budgets. Use the discount code to explore a variety of products and find the perfect gifts for everyone on your list.

Why Act Now? The Offer Will Not Last Forever

The Black Friday discount is live now but will not be around for long. Waiting too long could mean missing out on the chance to save 10% on all products. Since the code can only be used once per customer, it is best to plan your purchases and take advantage of this deal while it lasts.

Starting your Christmas shopping today means less stress later and more time to enjoy the holiday season with your loved ones.

Final Thoughts on This Black Friday Deal

This Black Friday, the 10% discount with code blackfriday25 is your ticket to smart, budget-friendly holiday shopping. The offer applies to all products, making it easy to find gifts that delight without overspending.

Do not wait to unwrap these savings. Use the code now, shop with confidence, and get your Christmas shopping done early. Your wallet and your gift recipients will thank you.
    `
  },
  {
    id: "sensory-pad-justice-system",
    title: "Sensory Pad used in Justice System help neurodiverse",
    author: "samboards19",
    date: "2024-09-04",
    readTime: "1 min read",
    content: `
The new Sensory pad is now being used within the justice system to support neurodiverse, have multiple orders for products lots of UK police forces to support neuro diverse within all their forces.

After successful trail with a sensory pad one police force has place  a large quantity of sensory pad as they have proved useful within the justice system to support  neuro diverse 


But can help in any work or home environment, as they provide valuable support and 

ree

assistance tailored to the specific needs of individuals. These resources can significantly enhance productivity and foster a more inclusive atmosphere, allowing everyone to contribute effectively. It is essential to hope that these supports are offered through programs such as Access to Work, which aims to provide financial assistance and practical support to those who require adjustments in their workplace or home settings. By facilitating access to necessary tools and resources, individuals can overcome barriers and thrive in their professional and personal lives. This initiative not only benefits the individual but also enriches the overall work culture by promoting diversity, understanding, and collaboration among all team members.
    `
  },
  {
    id: "medilink-southwest-awards-2024",
    title: "Samboards Ltd Triumphs at Medilink South-West Awards for Health Innovation",
    author: "samboards19",
    date: "2024-05-22",
    readTime: "2 min read",
    content: `
ree


On May 14th, 2025, Samboards Ltd marked a significant milestone by winning a prestigious award for innovation in health and care at the Medilink South-West Awards. This exciting event took place on the iconic SS Great Britain, a historic ship, making it a memorable backdrop for celebrating achievements in health innovation.


This remarkable award not only acknowledges the hard work of Samboards Ltd but also opens up opportunities for their participation in national awards. It highlights the company's ongoing commitment to enhancing healthcare through innovative solutions that respond to real-world challenges.


Unexpected Victory

In a moment filled with anticipation, representatives from Samboards Ltd were surprised when Cheryl, the award Sponsor from Health Innovation West of England, announced their win. Until that moment, the team had no inkling their efforts would receive such significant recognition.


Andrew Western, Of Samboards, proudly accepted the award  This marked a triumphant occasion not only for him but for the entire team, whose commitment and hard work in the health innovation sector have been unwavering. 


A Collaborative Journey

Samboards Ltd's partnership with Health Innovation West of England began in 2019 with their participation in the Health Innovation Programme. hoping this will lead  to  support  and  collaboration for the company's growth, giving them access to essential resources and support. 



The Role of Innovation in Health and Care

As healthcare needs rapidly evolve, innovation becomes vital. Samboards Ltd's products are designed to enhance patient care and streamline health services, focusing on improving outcomes for individuals and communities. Winning this award validates the company's mission and demonstrates the tangible benefits their innovations provide.


Research indicates that health innovations can improve patient outcomes by up to 30% in certain areas, such as managing chronic conditions through better monitoring and care coordination. This award serves as a reminder of the importance of investing in novel ideas and products that can dramatically transform health outcomes and elevate the quality of life for many.


Future Prospects

With this significant recognition, Samboards Ltd is gearing up to compete in the national awards, which will increase visibility for their offerings. The team is hopeful that this exposure will facilitate better understanding among more organizations about how Samboards' products can benefit patients and healthcare providers alike.


This recent achievement is not just a badge of honor; it is a powerful motivator for further advancements in healthcare solutions. 


Looking Ahead: A New Chapter

Winning the award at the Medilink South-West ceremony is just the beginning for Samboards Ltd. As they prepare for the national awards, the team remains committed to delivering innovative solutions that genuinely impact healthcare. 


The journey that began in 2019 with Health Innovation West of England has now entered an exciting phase, paving the way for more collaboration and broader reach. With strong faith in the value of innovation, Samboards Ltd is poised to continue enhancing healthcare outcomes for everyone.
    `
  },
  {
    id: "embracing-neurodiversity-adhd",
    title: "Embracing Neurodiversity: Understanding ADHD",
    author: "samboards19",
    date: "2024-05-22",
    readTime: "2 min read",
    content: `
ree


Introduction


In recent years, the concept of neurodiversity has gained significant attention, highlighting the unique ways in which our brains function. Among the various neurodiverse conditions, Attention-Deficit/Hyperactivity Disorder (ADHD) stands out due to its prevalence and the misconceptions surrounding it. This blog aims to shed light on ADHD, celebrate the strengths of neurodiverse individuals, and provide insights into living with and supporting those with ADHD.


What is Neurodiversity?


Neurodiversity is the idea that neurological differences, such as ADHD, autism, dyslexia, and others, are natural variations of the human brain. These differences should be recognized and respected as part of human diversity. Instead of viewing these conditions as deficits or disorders, neurodiversity advocates for understanding and valuing the unique strengths and perspectives they bring.


Understanding ADHD


ADHD is a neurodevelopmental condition characterized by symptoms of inattention, hyperactivity, and impulsivity. It affects both children and adults, though the presentation can vary widely among individuals. Some common symptoms include difficulty sustaining attention, forgetfulness, fidgeting, and impulsive decision-making.


The Strengths of ADHD


While ADHD is often discussed in terms of its challenges, it's crucial to recognize the strengths and positive traits associated with it. Many individuals with ADHD exhibit high levels of creativity, problem-solving skills, and the ability to think outside the box. Their hyperfocus on tasks they are passionate about can lead to remarkable achievements.


Living with ADHD


Living with ADHD can be both rewarding and challenging. Here are some strategies that can help:


Routine and Structure: Establishing a daily routine can provide stability and reduce the chaos that often accompanies ADHD.

Mindfulness and Relaxation: Practices like mindfulness and meditation can help manage stress and improve focus.

Support Systems: Building a strong support network of family, friends, and professionals can provide essential guidance and encouragement.

Embracing Strengths: Focusing on and nurturing the unique strengths of ADHD can lead to personal and professional success.


Supporting Neurodiverse Individuals


If you have a friend, family member, or colleague with ADHD, here are some ways to offer support:


Educate Yourself: Understanding ADHD and its impact can foster empathy and patience.

Be Patient and Flexible: Recognize that traditional methods may not always work and be open to alternative approaches.

Encourage Strengths: Help them identify and leverage their strengths in various aspects of life.

Provide Positive Reinforcement: Celebrate their achievements and offer constructive feedback.


Conclusion


Embracing neurodiversity and understanding ADHD is a step towards a more inclusive and accepting society. By recognizing the unique strengths and challenges of neurodiverse individuals, we can create environments where everyone has the opportunity to thrive. Whether you are living with ADHD or supporting someone who is, remember that diversity in thought and behavior enriches our world.
    `
  },
  {
    id: "sensory-products-mental-health",
    title: "How Innovative Sensory-Based Products Could Boost Mental Health for the Neurodiverse Community",
    author: "danwright",
    date: "2024-02-04",
    readTime: "2 min read",
    content: `
In today's fast-paced world, where stress and anxiety seem like unwelcome companions, finding innovative solutions to enhance mental health is crucial. For individuals within the neurodiverse community, the need for effective tools and products is even more pronounced. Sensory-based products have emerged as a promising avenue in mental health therapy, offering a unique approach that caters to a variety of needs and preferences. Let's delve into how these innovative products could positively impact the mental well-being of the neurodiverse community.


Understanding Sensory-Based Products


Sensory-based products work by engaging one's senses to promote relaxation, focus, or emotional regulation. These products draw on principles of sensory integration therapy, a method commonly used by occupational therapists to help individuals manage sensory input effectively. By incorporating elements that target different senses – such as touch, sight, sound, or smell – these products can create a calming and soothing environment that supports mental health.


Benefits for the Neurodiverse Community


1. Sensory Stimulation:


Sensory-based products offer diverse forms of stimulation that can be tailored to individual preferences. This customization is especially beneficial for those within the neurodiverse community who may have sensory sensitivities or seek specific types of sensory input for comfort and regulation.


2. Emotional Regulation:


Many individuals with neurodiverse conditions struggle with emotional regulation. Sensory-based products, like weighted blankets or fidget toys, provide tactile stimulation that can aid in soothing emotions and reducing anxiety levels.


3. Focus Enhancement:


For individuals with conditions like ADHD or autism, maintaining focus can be challenging. Sensory-based products, such as noise-canceling headphones or sensory mats, help create an environment conducive to concentration and productivity.


4. Promoting Relaxation:


Stress is a common adversary for mental health. Sensory products like aromatherapy diffusers or calming light displays can create a tranquil space that encourages relaxation and reduces feelings of overwhelm.


Case Study


Imagine a scenario where an individual with autism finds it challenging to remain focused and calm in crowded spaces. By using a sensory bracelet that emits soothing vibrations, this individual can regulate their sensory input, leading to increased comfort and reduced stress levels. As a result, they can navigate challenging environments with more ease and confidence.


Sensory Bracelet


Conclusion


Innovative sensory-based products have the potential to revolutionize the way we approach mental health care, especially for the neurodiverse community. By harnessing the power of sensory experiences, these products offer unique benefits that cater to individual needs and preferences. As we continue to prioritize mental health and well-being, embracing innovative tools like sensory-based products can pave the way for a more inclusive and supportive environment for all.


Next time you feel overwhelmed or agitated, consider exploring the realm of sensory-based products. You might just find a world of comfort and calm waiting to embrace you!


Remember, taking care of your mental health is a journey—let innovative sensory solutions be your trusted companions along the way.
    `
  },
  {
    id: "satpin-boards-game-changer",
    title: "Discover Samboards Ltd's SATPIN Boards: A Game-Changer for Literacy Learning",
    author: "samboards19",
    date: "2024-10-17",
    readTime: "2 min read",
    content: `
Hey there! Ever heard of Samboards Ltd's SATPIN Boards? If not, you're in for a treat. These boards are a game-changer for anyone wanting to brush up on their reading and writing skills. Let's dive in and see what makes them so special.

Samboards Ltd SATPIN Board designed to help learners practice the shapes of the six most important letters in the English language - S, A, T, P, I, and N

Samboards SATPIN Board
What's So Cool About SATPIN Boards?
Versatile Learning: With just six letters – S, A, T, P, I, and N – you can create over 100 different words. Yeah, that's a lot from just a few letters!

Hands-On Fun: These boards have a textured surface that makes tracing the letters a fun, sensory experience. It's like giving your fingers a mini workout.

User-Friendly: Whether you're a teacher, a parent, or just someone looking to improve their skills, the SATPIN Board is super easy to use.

Multi-Sensory Experience: Combining sight, touch, and movement, these boards help reinforce learning in a way that sticks. Perfect for those who like to learn by doing.


How Do They Work?
It's simple: you use your fingers to trace the shapes of the letters on the board. This builds muscle memory and helps the letters stick in your brain. And if you're feeling adventurous, you can use tools that add sound and vibrations for an extra sensory layer. It's like turning learning into an adventure!


Who's Going to Love These?
Kids: Perfect for young ones just starting to learn their letters and sounds.

Adults: Great for anyone looking to boost their literacy skills or recover from neurological conditions.

Teachers: An awesome addition to any classroom to keep students engaged and excited about learning.


The Bottom Line
The SATPIN Boards from Samboards Ltd aren't just another learning tool; they're your ticket to a more engaging and effective way to learn. Whether you're teaching, parenting, or just looking to sharpen your own skills, these boards are a must-have.


Ready to up your literacy game? Check out Samboards Ltd's SATPIN Boards and see the magic happen!
    `
  },
  {
    id: "ukraine-orphanage-fundraising",
    title: "Samboards Ltd Launches Heartfelt Fundraising Campaign to Support Ukrainian Orphanages",
    author: "samboards19",
    date: "2024-09-27",
    readTime: "2 min read",
    content: `
Samboards products arriving at the orphanage in Ukraine

Samboards products arriving at the orphanage in Ukraine.

In a truly heartwarming move, we at Samboards Ltd, a UK-based company known for our innovative sensory products, have set out on a mission to help children in Ukrainian orphanages and rehab centers. We're aiming to raise £10,000 by October 31st to donate essential sensory products that will support the development and well-being of these kids.


Our Mission
We specialize in creating sensory products that help reduce anxiety, manage stress, and improve focus for people with ADHD, mental health issues, dementia, and those recovering from strokes. Seeing the huge impact these products can have, we've decided to reach out to children in Ukraine who desperately need these resources.


Why Sensory Products?
Sensory products are super important for developing motor skills and cognitive functions. They offer therapeutic benefits that can help kids with special needs improve their focus, manage stress, and develop fine motor skills. For children in orphanages and rehab centers, these products can be a source of comfort and a tool for better mental and emotional health.


The Fundraising Campaign
Our goal is to raise £10,000 by the end of October. This money will go towards producing and distributing sensory products to various orphanages and rehab centers across Ukraine. It's not just about giving physical products but also about bringing hope and joy to children who have faced significant hardships.


Samboards Sensory Donation Ukraine
We are calling on the community to support this noble cause. You can donate directly through our website, and every contribution, no matter how small, will make a difference. By supporting this campaign, you're helping to provide essential tools that can significantly improve the quality of life for these children.


A Message from Us
"We are deeply committed to making a positive impact on the lives of children in need. Our sensory products have been proven to help with anxiety, stress, and focus, and we believe they can bring much-needed relief and joy to children in Ukrainian orphanages and rehab centers. We are grateful for any support and look forward to making a difference together," said Andy, the founder of Samboards Ltd.


Join the Cause
Join us in our mission to bring comfort and support to children in Ukraine. Visit our JustGiving fundraising campaign at the bottom of the page to learn more about the Samboards Sensory Donation Ukraine campaign and how you can contribute. Together, we can make a meaningful difference in the lives of these children.


Here is the donation link: https://www.justgiving.com/crowdfunding/supporting-ukraine?utm_term=RqJvbD5Rr


or Scan the QR code: 

QR code to scan to go directly to Samboards JustGiving fundraising campaign
    `
  },
  {
    id: "embracing-neurodiversity",
    title: "Embracing Neurodiversity: The Power of Sensory Products",
    author: "samboards19",
    date: "2024-09-20",
    readTime: "2 min read",
    content: `
In recent years, the idea of neurodiversity has really started to get the attention it deserves. Neurodiversity is all about recognizing that neurological differences, like autism, ADHD, dyslexia, and other conditions, are just natural variations of the human brain. This perspective encourages us to see these differences not as deficits, but as unique strengths and ways of thinking.


Understanding Neurodiversity
People who are neurodivergent often experience the world in unique ways, which can bring both challenges and special abilities. For example, someone with ADHD might struggle with focusing but often shines in creativity and problem-solving. Similarly, individuals on the autism spectrum may have incredible focus and attention to detail.


The Importance of Neurodiversity Sensory Products
One common challenge for neurodivergent individuals is sensory processing. Sensory processing issues can make everyday environments overwhelming, leading to anxiety and stress. This is where neurodiversity sensory products come in. These products are designed to help manage sensory input, providing calming and focusing effects.


Spotlight on Samboards Sensory Products
Samboards, a UK-based company, is leading the way in creating innovative sensory products. Their range is specifically designed to reduce anxiety, manage stress, and improve focus for people living with ADHD, autism, and other neurodivergent conditions.


Key Features of Samboards Sensory Products:
Anxiety Reduction: Samboards products provide tactile stimulation, which can help soothe and calm the nervous system.

Stress Management: These products offer a sensory outlet, helping to manage stress and prevent sensory overload.

Focus Enhancement: The sensory input from Samboards products can aid in improving concentration and focus, making them valuable tools for both children and adults.

Versatility: The products are suitable for a wide range of users, including those with ADHD, autism, and other neurodiverse conditions.


Real-World Applications
Samboards products are used in various settings, from homes and schools to workplaces and therapeutic environments. For instance, Devon and Cornwall Police have introduced Samboards sensory tools to support neurodivergent student officers, helping them thrive in their training and duties.


Conclusion
Embracing neurodiversity means recognizing and supporting the unique needs of neurodivergent individuals. Sensory products like those from Samboards play a crucial role in this support, offering practical solutions to manage sensory challenges and enhance overall well-being. By integrating these tools into daily life, we can create more inclusive and supportive environments for everyone.


Ready to explore the world of sensory products? Discover our wide range of innovative items designed to soothe your senses and enhance your overall quality of life. We're sure we have the perfect sensory product for you.
    `
  },
  {
    id: "dementia-sensory-stimulation",
    title: "Understanding Dementia and the Benefits of Samboards Sensory Pads",
    author: "samboards19",
    date: "2024-09-03",
    readTime: "2 min read",
    content: `
Dementia is a broad term used to describe a decline in cognitive function severe enough to interfere with daily life. Alzheimer's disease is the most common form of dementia, but there are many other types, each affecting the brain in different ways. Symptoms often include memory loss, confusion, difficulty with language, and changes in mood and behaviour.


The Role of Tactile Sensory Stimulation in Dementia Care
One innovative approach to managing dementia symptoms is through sensory stimulation. Sensory stimulation involves engaging the senses to help improve cognitive function, mood, and overall well-being. This is where Samboards Sensory Pads come into play.


What Are Samboards Sensory Pads?
Samboards Sensory Pads are tactile stimulation tools designed to provide a calming and engaging experience for individuals with dementia. These pads feature various textures that users can touch and feel, which helps to stimulate the brain and promote a sense of calm. The pads are lightweight, portable, and easy to use, making them an excellent tool for both caregivers and individuals with dementia.


Benefits of Samboards Sensory Pads

Promotes Calmness: The tactile stimulation provided by Samboards Sensory Pads can help reduce agitation and anxiety, common symptoms in dementia patients.

Improves Memory: Research has shown that sensory stimulation can enhance both short-term and long-term memory.

Enhances Mood: By providing a chemical-free way to stimulate the brain, these pads can improve overall mood and contribute to a better quality of life.

Supports Cognitive Function: Regular use of sensory pads can help maintain cognitive function and slow the progression of dementia symptoms.


Real-Life Applications
Many caregivers and healthcare professionals have reported positive outcomes from using Samboards Sensory Pads. For example, they have been used to help individuals with dementia focus during activities, reduce stress during medical appointments, and even improve sleep quality by providing a calming bedtime routine.


"With my nan having COPD with many other health issues, we had to start using breathing exercises, the Samboards have really helped my nan with her breathing by following the various patterns. One evening, my Nans Oxygen levels dropped on the machine very low, We did the exercises with the Samboard and her reading went up. My point is these boards have really helped, not only does it help with her exercises but it also distracts her panic when she is struggling, it is by her side 24/7 and she uses it every single day".                                                                             
— Elderly, 2020


Conclusion
Dementia can be a challenging condition to manage, but innovative tools like Samboards Sensory Pads offer a promising way to improve the quality of life for those affected. By incorporating sensory stimulation into daily care routines, caregivers can help reduce anxiety, improve memory, and enhance the overall well-being of individuals with dementia.


If you are a caregiver or know someone with dementia, consider exploring the benefits of Samboards Sensory Pads. They might just make a significant difference in managing the symptoms and improving the quality of life for your loved one.


Ready to explore the world of sensory products? Discover our wide range of innovative items designed to soothe your senses and enhance your overall quality of life. We're sure we have the perfect sensory product for you.
    `
  },
  {
    id: "transform-your-calm",
    title: "Transform Your Calm: Discover Sensory Products for Stress Relief and Anxiety Management",
    author: "Emma Morris",
    date: "2024-08-22",
    readTime: "4 min read",
    content: `
In today's fast-paced world, stress and anxiety have become increasingly common. These conditions can significantly impact our mental and physical well-being, leaving us feeling overwhelmed, exhausted, and isolated.


At Samboards, we understand the challenges individuals face and are dedicated to providing innovative solutions that promote relaxation and tranquillity. Our focus is on sensory products, carefully designed to stimulate the senses and create a sense of calm. Whether you're dealing with anxiety, stress, dementia, autism, or simply seeking a moment of peace, our products offer a gentle and effective way to alleviate discomfort and improve overall quality of life.


In this blog, we'll delve into the science behind sensory stimulation, explore the various types of sensory products available, and provide practical tips for incorporating them into your daily routine. Join us as we discover how these products can help you find solace and restore your inner balance.


Understanding the Science Behind Sensory Products
To truly grasp the power of sensory products, it's essential to delve into the intricate workings of our nervous system. Our senses – sight, sound, touch, taste, and smell – act as gateways to the world, constantly collecting and processing information.

This sensory input plays a crucial role in shaping our perception of reality and influencing our emotional state.  


When we experience stress or anxiety, our nervous system can become overwhelmed, leading to heightened arousal and physical symptoms like a racing heart, rapid breathing, and muscle tension. Sensory products, by strategically engaging our senses, can help to regulate these responses. By providing a calming and grounding effect, they can help reduce stress and anxiety.  


The science behind sensory stimulation is rooted in neuroplasticity, the brain's remarkable ability to change and adapt in response to experiences. By repeatedly exposing our senses to specific stimuli, we can create new neural pathways and strengthen existing ones. These neural connections can help to rewire our brain's stress response, promoting a greater sense of calm and well-being.


Types of Sensory Products and Their Benefits

Visual:

Colour Therapy: Specific colours can evoke different emotions and moods. For example, blue is often associated with calmness and tranquillity, while green can promote relaxation.

Light Therapy: Exposure to light can regulate sleep patterns and improve mood. Lightboxes and mood lamps can provide a therapeutic dose of light.

Visual Patterns: Patterns can stimulate the brain and provide a sense of order and structure.


Auditory:

Nature Sounds: The sounds of nature, such as birdsong, ocean waves, or rainfall, can create a calming and soothing atmosphere.

Music Therapy: Listening to music can evoke emotions and promote relaxation. Certain types of music, like classical or instrumental, are often recommended for stress reduction.

White Noise: White noise can mask distractions and help to improve sleep quality.


Tactile:

Weighted Blankets: The pressure from weighted blankets can provide a sense of grounding and relaxation.

Fidget Toys: Small, tactile objects can help to reduce anxiety and improve focus.

Texture Therapy: Exploring different textures can stimulate the senses and provide sensory input.


Olfactory:

Aromatherapy: Essential oils can be inhaled to promote relaxation and reduce stress. Lavender, chamomile, and eucalyptus are popular choices.

Scented Candles: Scented candles can create a soothing ambience and evoke pleasant memories.


Gustatory:

Taste Therapy: Certain foods and beverages can have a calming effect. For example, warm tea or soothing herbal drinks can be comforting.

Mindful Eating: Paying attention to food's taste, texture, and aroma can enhance the sensory experience and promote mindfulness.


Incorporating Sensory Products into Daily Life
Integrating sensory products into your daily routine can be a simple yet powerful way to promote relaxation and reduce stress. Here are some practical tips:


Create a calming sanctuary: Designate a specific area in your home as a peaceful retreat. Fill it with soft textures, soothing colours, and calming sounds.

Incorporate sensory activities: Incorporate sensory activities into your daily routine, such as taking a warm bath with scented bath salts or listening to calming music while reading.

Mindful sensory experiences: Practice mindfulness by paying attention to your senses. Notice the textures of your clothes, the sounds around you, or the taste of your food.

Experiment and find what works for you: Everyone's sensory preferences are unique. Experiment with different products and activities to discover what brings you the most comfort and relaxation.

Seek professional guidance: If you're struggling to manage stress or anxiety, consider consulting with a healthcare professional or therapist who can provide personalised recommendations and support.


"Used the prickly tile during a presentation that I had to give. I found it a distraction from the nerves of presenting. It took my mind away from the fear of stuttering. It worked, and I felt incredibly relaxed whilst carrying out the presentation".               
— NHS Employee

Conclusion
Sensory products offer a powerful tool for managing stress and anxiety, providing a gentle and effective way to promote relaxation and well-being. By understanding the science behind sensory stimulation and incorporating these products into your daily life, you can experience a renewed sense of peace and tranquillity.


Ready to explore the world of sensory products? Discover our wide range of innovative items designed to soothe your senses and enhance your overall quality of life. We're sure we have the perfect sensory product for you. 
    `
  },
  {
    id: "devon-cornwall-police",
    title: "Devon and Cornwall Police introduce new learning tool to support neurodiverse student officers",
    author: "samboards19",
    date: "2023-09-18",
    readTime: "2 min read",
    content: `
Devon and Cornwall Police have introduced a new learning tool to help support neurodiverse student officers.


Lead by the Performance and Inclusion (P&I), the new Sensory library Boards (Samboards); have been funded using a grant from the National Police Autism Association (NPAA) and will be used primarily to support those students who are suspected or diagnosed as having a neurodivergent condition.


They are designed to help persons with Attention Deficit Hyperactivity Disorder (ADHD), or sensory issues within the classroom environment. Side effects of ADHD and autism can make it more challenging for students to participate in study and other activities so by using a Samboards this can help increase concentration and assist with focusing.


Police Constable John Holland, NPAA lead coordinator, Neurodiversity Support Network Peer Support SPOC and P&I team member within Devon and Cornwall, said: "The approach the P&I team are utilising to support neurodiverse student officer has been recognised by the College of Policing as a supportive measure to ensure our officers are being given an equally opportunity to thrive within the learning environment and is just one of many supportive measures we are exploring.


Police Sergeant John Nelson, Chair of the National Police Autism Association, said: "We are delighted to be able to put some of our NPCC grant towards helping neurodiverse student officers to achieve their potential and to making the police service a more inclusive employer for all."


Police staff member Zoey Empson, Victim Care Supervisor and Neurodiversity Support Network Chair for Devon and Cornwall Police said: "I am pleased Devon and Cornwall Police are taking on board the differing needs of their neurodiverse employees and are putting in place many supportive functions and reasonable adjustments to help us thrive; in turn giving our communities a better service in response.


I am very much looking forward to the future of policing and supporting further projects to support developmental growth in this regard."


Andy Western from Samboards said: "It has been great working with Devon and Cornwall police and PC John Holland regarding their introduction and use of our sensory products to support neurodiverse students. It is nice to see the benefits Samboards sensory products bring, being introduced by Devon and Cornwall police as part of their inclusion programme."
    `
  },
  {
    id: "ukraine-refugee-appeal",
    title: "Samboards launches appeal to help continue donations to children and young adults with special educational needs in Ukraine",
    author: "samboards19",
    date: "2023-08-06",
    readTime: "1 min read",
    content: `
A BUSINESS based in Cam has launched an appeal to help continue donations to children and young adults with special educational needs in Ukraine.


Samboards, which creates specialist sensory support products for people with complex disabilities, has been donating their products to refugees in collaboration with Aid for Ukraine Gloucestershire.


So far, the Cam company has donated a range of products, such as its sensory libraries and SATPIN boards, to two orphanages and a rehabilitation centre.

Different from fidget spinners, the products have been designed with different textures that, when felt by the user, trigger the feel-good hormone dopamine while also creating neural pathways in your brain.


Designers say the products help those with complex needs ranging from ADHD, autism, stress, anxiety, dementia, and Alzheimer's.


Meanwhile, one of its products known as the SATPIN board is designed for younger children, to help make learning English more enjoyable and engaging.


A spokesperson for Aid for Ukraine Gloucestershire said: "They have so far enjoyed using them.


"Thanks to Andy's knowledge, we were able to identify the best products to suit the needs of the recipients.


"And further talked about the advantages of using the SATPIN boards.


"The orphanages like using the SATPIN board to improve their English reading and writing skills."


Samboards CEO Andrew Western said: "I am very moved by the positive impact these boards have had on people's lives.


"And we seek further sponsorship, to be able to provide the products to all Ukraine refugees, young or old."


If you would like to provide sponsorship contact: samboards19@aol.com
    `
  },
  {
    id: "hartpury-tech-box-green-products",
    title: "Hartpury Tech Box Park members join forces to create green sensory products",
    author: "samboards19",
    date: "2022-09-22",
    readTime: "2 min read",
    content: `
Two of Hartpury's Tech Box Park members have joined forces to create a novel range of green products designed to reduce anxiety, manage stress, and keep the focus on people living with ADHD, Mental Health, and Dementia.


AJW Solutions UK Ltd, one of the South West's leading manufacturers of machined and fabricated products, together with Novazera, a company developing Biodegradable Argi-Plastics have worked together in Hartpury's 'sandbox' environment to create an environmentally friendly range of 'Samboards' – innovative (Sensory Activated Motor-skills) Sensory Pads.


Proven to alleviate the effects of cognitive conditions, including dementia, the Sensory Pads have been designed so that when they are touched, they promote positive cognitive responses and release endorphins by distracting the brain from negative situations and feelings.


The Samboards Sensory Pads have seven different textures which provoke different cognitive reactions, providing a range of purposes. These include supporting breathing exercises, improving concentration, calming, and improving hand control and fine motor skills.


The members have used their base at Hartpury to test and develop alternate plastics in their products including different weights and colours, moving away from producing synthetic plastic products towards a much more sustainable and environmentally friendly product – Argi Biodegradable Plastic.


Andrew Western, CEO of Samboards Ltd said: "I am enthusiastic about our products and the mental health and wellbeing benefits using our 'touch and feel' products bring to our users. The testing and trialling of the new Argi-Biodegradable Plastic products with Novazera is a brand-new innovation for us and something we are very excited about."


"We aim to develop more products in our range using this alternative biodegradable plastic and develop and roll out new products specifically designed to support mental health and wellbeing. Our products could be used in a range of settings from dementia patients to students and farmers."


Brian Powell MD from Novazera commented: "It's great to work alongside Samboards Ltd during the development of their sensory pads, and even more satisfying to know that the collaboration through Hartpury has led to real-world use of our Biopolymers. Having the opportunity to demonstrate how Agricultural by-products can be transformed into objects that have real benefits makes us extremely proud."


Hartpury's Tech Box Park facility funded by the European Regional Development Fund (ERDF), the GFirst LEP 'Getting Building Fund' and the Elizabeth Creak Charitable Trust is dedicated to enabling the growth of innovative local businesses looking to develop new or existing products and accelerate them into the Agri-tech market.
    `
  },
  {
    id: "dementia-sensory-boards-hollies",
    title: "Sensory Boards: A Revolutionary Tool for Dementia Care",
    author: "samboards19",
    date: "2022-03-22",
    readTime: "6 min read",
    content: `
<p>Nice to be writing once more and letting you know what we've been up to in recent times.</p>

<p>I have been working with Andrew Western, the CEO of Samboards and he has been introducing me to the wide range of products that are proving to be an effective way of helping to calm people living with dementia when they are feeling anxious or overwhelmed.</p>

<div style="text-align: center; margin: 2rem 0;">
  <img src="/blog/sam-logo-teal.png" alt="Samboards logo" style="max-width: 300px; width: 100%; height: auto;" />
</div>

<p>The sensory boards that Samboards have created are uniquely designed to be used for either distraction or enjoyment. Touching and feeling the board exercises your hands, increases messages to your brain, and releases natural chemicals which can help a person feel motivated, and improve the sense of well-being.</p>

<p>Benefits reported by other users include; increased concentration and focus, reduced anxiety, improved circulation and fine motor skills and a greater sense of calm and well-being.</p>

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin: 2rem 0;">
  <img src="/blog/sensory-board-blue-texture.png" alt="Blue textured sensory board" style="width: 100%; height: auto; border-radius: 8px;" />
  <img src="/blog/sensory-board-orange-texture.png" alt="Orange textured sensory board" style="width: 100%; height: auto; border-radius: 8px;" />
  <img src="/blog/sensory-board-purple-swirl.png" alt="Purple sensory board with swirl pattern" style="width: 100%; height: auto; border-radius: 8px;" />
</div>

<h3>How the Sensory Board Works</h3>

<p>The sensory board has seven different textures on it. Move your fingers around the textures around the board and think of how they feel. Touching and moving around in these textures can give the brain something new to think about and produce "feel good" hormones.</p>

<p>There are no timeframes or limits on how much the board can be used. They work effectively as part of a daily routine to stimulate fine motor skills for example or they can be used whenever you need them to feel more calm and focused.</p>

<p>The six textures on the front and one on the back are designed with a different feel to each of them. Each texture is experienced through touch, using the hands and fingers but it can also work if a tool is used in the mouth or by using other areas of your skin.</p>

<div style="text-align: center; margin: 2rem 0;">
  <img src="/blog/brain-illustration.png" alt="Brain illustration showing neural pathways" style="max-width: 600px; width: 100%; height: auto; border-radius: 8px;" />
</div>

<p>Some of the textures are designed to recreate images of nature which are known to be soothing. When the texture is felt, different feedback or feelings are created, the blood flow to the outside of the brain increases and hormones are released. The sensory needs can be met by one or more of these textures.</p>

<p>By touching the board and finding new textures to explore, the body releases dopamine, which is a feel-good stimulating hormone. The act of touch also produces messages through the nervous system which can then move blood in the brain away from the amygdala reducing anxiety and stress.</p>

<p>The swirl pattern (represented in blue) helps with breathing exercises.</p>

<p>While using the sensory pad, the user may feel calmer and more in control of their emotions. A calm mind can make learning easier and make better choices. They can feel more engaged and interested in the world around them.</p>

<p>The board also helps to develop hand control and small motor skills. By using your hands and fingers to touch textures that you may like, you can improve your mood and your small motor skills. This can lead to better hand control for other tasks like feeding yourself or doing up buttons.</p>

<div style="text-align: center; margin: 2rem 0;">
  <img src="/blog/orange-sensory-board-hand.png" alt="Hand touching orange sensory board" style="max-width: 600px; width: 100%; height: auto; border-radius: 8px;" />
</div>

<p>The tactile experience can also help in memory building, memory storing and memory retrieval. By experiencing something different and new to you, you are building new pathways in your brain. The more pathways that you have in your brain, the more accessible routes your thoughts can take, which makes brain ageing and memory loss less noticeable. If your tactile sensors have been under-stimulated, and that part of your brain has reduced its function, it is possible to rebuild your sensitivity and the area of the brain it lives in.</p>

<p>The boards are made to a safe standard and are dishwasher safe. Cleaning does not require any specialist products: simply pop it in the dishwasher or clean it by hand using hot soapy water or anti-bacterial cleaning sprays. It is recommended that you wash your board after each time that you use it.</p>

<h3>Use of the board in a dementia setting</h3>

<p>Andrew has been working with The Hollies Care Centre in Dursley. The Hollies Care Centre is a friendly and supportive care home community providing specialised and tailored nursing care, dementia care, respite care, end-of-life care and residential apartments. It provides round-the-clock care offered by a team of dedicated and well-trained staff. It is well-established and accredited with the Gold Standards Framework Award. Dementia Care follows the internationally recognised "Household model" of person-centred care. It provides a full range of services to meet the changing needs of its residents. It is set in a beautiful park overlooking the picturesque village of Dursley.</p>

<p>Recently, Andrew visited The Hollies site with local MP, Right Honourable Siobhan Baillie, where they have been using his boards as a tool for helping their clients relax and focus.</p>

<div style="text-align: center; margin: 2rem 0;">
  <img src="/blog/hollies-care-centre-visit.png" alt="Visit to The Hollies Care Centre with MP Siobhan Baillie" style="max-width: 700px; width: 100%; height: auto; border-radius: 8px;" />
</div>

<p>The Rt Hon Member of Stroud was so impressed with the way that the home was run and the effects that Andrew's products had in helping people living with dementia to calm and focus, that she wrote this letter of approval.</p>

<div style="text-align: center; margin: 2rem 0;">
  <img src="/blog/siobhan-baillie-letter.png" alt="Letter of support from Siobhan Baillie MP" style="max-width: 500px; width: 100%; height: auto; border-radius: 8px;" />
</div>

<h3>Testimony</h3>

<p>Here is some of the feedback that Samboards' products have received thus far.</p>

<p><strong>Salisbury NHS</strong> - Working in a hospital under the current circumstances is particularly challenging and stressful. With the job of the site manager, ensuring patients flow and admission are needed safely around the trust, a lot of stress is accumulated. My colleague presented us with a stress relieving device which helps take the mind off a million different thoughts and helps with sewing a line of thinking back together. I personally have mild ADHD and it helped me to focus on goals and targets one step at a time without drifting into a million different tasks. A very positive tool and comes in a portable form which is very helpful as well as being safe and easily wipeable.</p>

<p><strong>NHS Employee</strong> - Used the prickly tile during a presentation that I had to give. I found it a distraction from the nerves of presenting. It took my mind away from the fear of stuttering. It worked and I felt incredibly relaxed whilst carrying out the presentation.</p>

<p><strong>Parent</strong> - Gave one to my youngest child during homeschooling to try and keep him focused. I found the days when he had the tile to fiddle with, his concentration improved and he was less inclined to get out of his chair.</p>

<p><strong>Professional</strong> - Used it at work to reduce my stress levels when confronted with situations that would normally create some levels of anxiety. I found having it on my lanyard meant that it was easy to access and provided a level of distraction.</p>

<p><strong>A relative of an elderly patient living with COPD</strong> - With my Nan having COPD and many other health issues we had to implement breathing exercises. The SAMBOARDS have really helped my Nan with her breathing by following the various patterns. One evening, my Nan's oxygen levels dropped to a very low reading on her machine. We did the exercise with the Sam board and her reading went up on her machine. My point is that the boards have really helped, not only does it help her with her exercises, but it also distracts her panic when she is struggling. It is by her side 24/7 and she uses it every single day.</p>

<p><strong>Headway</strong> - Samboards reached out to Headway in order to use their products to support social and cognitive rehabilitation. Results found that it supported users' neurological condition and helped to keep them focused.</p>

<p>Impressions were documented as:</p>

<p>"Yes, 100%. I enjoyed using the Sam boards very much."</p>

<p>"I enjoyed exploring different shapes"</p>

<p>"Feeling the many bumps and ridges, I enjoyed that because of my condition."</p>

<p>"Sliding hand on the swirl and the wave shapes was very enjoyable."</p>

<p>"Refocuses the mind, I rate the board 9/10 and the instant reward was 8/10."</p>

<p>The board and other sensory products can also be used as an aid in stroke recovery and many other neurological conditions. It has been used to help those with anxiety issues to aid with sleeping problems. It has also helped adults with learning disabilities when feeling agitated and has been noticed to improve mood and reduce levels of incidents.</p>

<h3>Personal Testimony</h3>

<p>My 11-year-old daughter suffers from anxiety issues. Just before Christmas, we were travelling on the motorway when my exhaust snapped and I had to pull onto the hard shoulder. We vacated the car and made our way behind the barrier. The area behind the barrier was a nettle and prickly shrubs overgrowth that took quite a bit of negotiating. Between this and the noise made by the oncoming traffic rushing past and the fact that we were looking at a six-hour wait before any recovery vehicle turned up, my daughter became quite anxious. Now I always keep one of the Sam boards on the back seat of the car for presentation purposes when talking about this product. My daughter asked me if we could go back to the car so that she could get something. We made our way back to the car and she retrieved the Sam board from the back seat. We went back behind the barrier and she started to trace the patterns on the board with her finger. I was amazed at what a calming influence this had on her and she remained calm and focused until her Uncle Paul turned up on his white BMW (and if you ever want to see my daughter chuckle it was getting into a BMW after driving in a Honda Jazz with her Uncle) to get her back home whilst I waited for the recovery vehicle.</p>

<div style="text-align: center; margin: 2rem 0;">
  <img src="/blog/girl-using-sensory-board.png" alt="Young girl using a sensory board" style="max-width: 500px; width: 100%; height: auto; border-radius: 8px;" />
</div>

<p>Well, I hope this gives everyone a good flavour of the great work that these boards can do. I cannot recommend them highly enough.</p>

<p>Until next time</p>
    `
  },
  {
    id: "library-squares-dyslexia-testimonial",
    title: "How Sensory Library Squares helped me with dyslexia",
    author: "samboards19",
    date: "2021-02-11",
    readTime: "2 min read",
    content: `
<p>When I received my Library Squares from Samboards, my main aim was to challenge how well they would work for me. I have always struggled with my dyslexia after being diagnosed at age seven. I struggle with my short term memory, maintaining concentration – especially in this new world of zoom calls – extremely difficult where the norm of physical communication is gone.</p>

<p>Library Squares are a small, simple and textured product designed for sensory stimulation. It is the perfect size to attach to a keychain, lanyard, bag or to carry in your pocket for easy access. It comes in three designs; points, rock and unicorn library. This gives sensory feedback which encourages the release of feel good hormones while creating neural pathways in your brain.</p>

<p>As soon as my next zoom call began I whipped out my Library Square from my keychain, I found that it worked for me when listening, when I needed to take in and retain information which is something I have always struggled with. The Library Square is small enough that it doesn't become a chore to get out and put away when other activities or both hands are needed, even easier to grab when my concentration starts to wander. My favourite was the rock design, it was soft and was soothing to touch.</p>

<p>I attached it to my keychain which I found was most useful as it was something I rarely lose and allowed me to grab it at a moment's notice. For me the Library Squares are something I want to adapt more into my daily life, especially once everything starts growing towards normality again.</p>

<p>I was also curious as to how my sister would react to the Library Squares, she is currently studying for her GCSE's and also has dyslexia. She enjoyed the unicorn design the most, finding it more comforting, attaching it to her USB and keeping it beside her most of the time. For her she preferred that it was a visual image as well as a sensory object, though she is looking forward to hopefully having new designs and colours to fiddle with.</p>

<p>Overall, I was pretty impressed and found myself using it more than I thought with it being so adaptable to any situation.</p>

<p>If you want more information on Library Squares or Samboards please feel free to access the Samboards website at: <a href="https://www.samboards.co.uk/" target="_blank" rel="noopener noreferrer" style="color: #6EEDC1;">https://www.samboards.co.uk/</a></p>
    `
  },
  {
    id: "library-squares-homeschooling-lockdown",
    title: "Library Squares: Supporting homeschooling during lockdown",
    author: "samboards19",
    date: "2021-02-11",
    readTime: "3 min read",
    content: `
<p>It's fair to say that lockdown has been a challenge for all of us, adding increased stress and distractions to the adjustment of schooling and daily life. You might be homeschooling a child or possibly a parent supporting your child through countless online classes? No matter what your situation is we are all looking for something to comfort, relax and distract us.</p>

<p>Samboards are a range of sensory products designed to reduce anxiety, manage stress and maintain focus for a wide range of people including; people with learning differences, people living with dementia/stroke recovery and people with anxiety.</p>

<p>Library Squares are a small, simple and textured product designed for sensory stimulation. It is the perfect size to attach to a keychain, lanyard, bag or to carry in your pocket for easy access. It comes in three designs; points, rock and unicorn library. These give sensory feedback which encourages the release of feel good hormones while creating neural pathways in your brain.</p>

<p>Children can feel the squares during online calls whilst listening to their teachers to maintain and stimulate their listening and concentration, when doing activities and tasks which need focus and can be adapted into all parts of homeschooling. In a research project carried out by MBA in order to use our Library Squares to support home-schooling, results found that over 70% of users found their concentration improved and children were less likely to be distracted.</p>

<p>Impressions were also documented as; "I keep picking it up", "I instantly fiddled with it", "Loved the unicorn one, like the feel of the others".</p>

<p><strong>Testimonial:</strong> "Used the prickly tile during a presentation that I had to give. I found it a distraction from the nerves of presenting. It took my mind away from the fear of stuttering. It worked and I felt incredibly relaxed whilst carrying out the presentation"</p>

<p>Adapting Library Squares into your home-schooling routine during this lockdown is a great way for you and your child to find ways to deal with the challenges that arise when home-schooling, finding a simple solution to mitigating anxiety, concentration and opening up to sensory feelings.</p>

<h3>Parent Testimonial</h3>

<p>My children are easily distracted (like most) we tried the Samboards while reading for my daughter. We noticed a improvement on her concentration while reading. This really helped her and she uses it most time she reads as she also notices a difference.</p>

<p>We also tried the Samboard for our son. Who has always not been the best to go to sleep at night. I put it on his bedside table to see what he thought. When I went up to check on him 10 minutes later he was quietly led in bed playing with it. I sat and explained to him that it was treasure and that he could play with it all night. Thinking he was allowed to play with it all night, he played with the Samboard until he fell asleep. We have used this method a couple of times and have noticed a MASSIVE improvement with his sleep when playing with it. (He likes to search for his treasure in bed the morning after, it has become quite a game).</p>

<p>The main thing is that we are noticing a big difference, it's helped calm him at bed time as well as helping him fall asleep.</p>

<p>Thank you Samboards, we really had tried so many things but this has been the best improvement we have seen.</p>

<p>For more information please feel free to access the Samboards website at: <a href="https://www.samboards.co.uk/" target="_blank" rel="noopener noreferrer" style="color: #6EEDC1;">https://www.samboards.co.uk/</a></p>
    `
  }
];

export default function Blog() {
  const [selectedBlog, setSelectedBlog] = useState<typeof blogPosts[0] | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleBlogClick = (blog: typeof blogPosts[0]) => {
    setSelectedBlog(blog);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setTimeout(() => setSelectedBlog(null), 200);
  };

  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h1 className="text-[54px] leading-[1.1] font-bold mb-4 tracking-wide">Latest News</h1>
              <p className="text-xl text-slate-400">
                Stay updated with the latest news, insights, and stories from the Samboards community.
              </p>
            </div>

            {blogPosts.length === 0 ? (
              <div className="text-center py-16">
                <p className="text-slate-400 text-lg">No blog posts yet. Check back soon!</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                {blogPosts.map((post) => (
                  <button
                    key={post.id}
                    onClick={() => handleBlogClick(post)}
                    className="group text-left rounded-2xl bg-slate-900/70 border border-emerald-300/20 shadow-lg shadow-black/50 hover:shadow-[0_20px_50px_rgba(16,185,129,0.3)] hover:-translate-y-0.5 hover:border-emerald-300/40 transition-all duration-300 p-6"
                  >
                    {post.date && (
                      <time className="text-sm text-slate-400/80 font-medium">{post.date}</time>
                    )}
                    <h2 className="text-xl font-semibold text-emerald-300 mt-2 group-hover:text-emerald-200 transition-colors">
                      {post.title}
                    </h2>
                  </button>
                ))}
              </div>
            )}
          </div>
        </section>
      </Page>

      <BlogModal isOpen={modalOpen} onClose={handleCloseModal} blog={selectedBlog} />
    </div>
  );
}
